import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _class, _class2, _CourseDetailsHeader;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import AppContext from '../../../../context';
import CourseDetailsHeader from '../../CourseDetailsHeader/CourseDetailsHeader';
import Discussion from '../../../../components/Discussion/Discussion';
var CourseDetailsDiscussion = (_dec = connect(function (state) {
  return {
    course: state.courseDetails.course
  };
}), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(CourseDetailsDiscussion, _React$Component);
  var _super = _createSuper(CourseDetailsDiscussion);
  function CourseDetailsDiscussion() {
    _classCallCheck(this, CourseDetailsDiscussion);
    return _super.apply(this, arguments);
  }
  _createClass(CourseDetailsDiscussion, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {}, void 0, _CourseDetailsHeader || (_CourseDetailsHeader = /*#__PURE__*/_jsx(CourseDetailsHeader, {})), /*#__PURE__*/_jsx(Discussion, {
        ts: _.get(this, 'context.query.ts')
      }));
    }
  }]);
  return CourseDetailsDiscussion;
}(React.Component), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class);
export { CourseDetailsDiscussion as default };